/* eslint-disable */
module.exports = {
  emojiLetters: {
    'a'       : ['🅰'],
    'ab'      : ['🆎'],
    'atm'     : ['🏧'],
    'b'       : ['🅱'],
    'back'    : ['🔙'],
    'c'       : ['©', '☪'],
    'cl'      : ['🆑'],
    'cool'    : ['🆒'],
    'd'       : ['🌛', '👌'],
    'e'       : ['📧'],
    'end'     : ['🔚'],
    'f'       : ['🎏'],
    'g'       : ['🎼', '🌀'],
    'h'       : ['♓'],
    'i'       : ['ℹ','🕕', '📍'],
    'id'      : ['🆔'],
    'j'       : ['🎷', '🏑'],
    'k'       : ['🎋'],
    'l'       : ['🕒', '💪'],
    'm'       : ['♏', '〽', 'Ⓜ'],
    'n'       : ['📈', '🎵'],
    'ng'      : ['🆖'],
    'new'     : ['🆕'],
    'o'       : ['🅾', '⭕', '☮'],
    'ok'      : ['🆗'],
    'on'      : ['🔛'],
    'oo'      : ['➿', '🐽'],
    'off'     : ['📴'],
    'p'       : ['🅿'],
    'q'       : ['🍭', '🍳'],
    'r'       : ['®'],
    's'       : ['⚡', '💲', '💰'],
    'sy'      : ['💱'],
    'sos'     : ['🆘'],
    'soon'    : ['🔜'],
    't'       : ['✝', '➕'],
    'tm'      : ['™'],
    'top'     : ['🔝'],
    'u'       : ['⛎'],
    'up'      : ['🆙'],
    'v'       : ['♈'],
    'vs'      : ['🆚'],
    'w'       : ['〰', '👐'],
    'wc'      : ['🚾'],
    'x'       : ['❌', '✖', '❎'],
    'y'       : ['🌱', '🍸'],
    'z'       : ['💤'],
    'zz'      : ['💤'],
    'zzz'     : ['💤'],
    '+'       : ['➕'],
    '-'       : ['➖'],
    '!'       : ['❗️', '❕'],
    '!!'      : ['‼️'],
    '?'       : ['❓', '❔'],
    '!?'      : ['⁉️'],
    '$'       : ['💲'],
    '0'       : ['0️⃣'],
    '1'       : ['1️⃣'],
    '2'       : ['2️⃣'],
    '3'       : ['3️⃣'],
    '4'       : ['4️⃣'],
    '5'       : ['5️⃣'],
    '6'       : ['6️⃣'],
    '7'       : ['7️⃣'],
    '8'       : ['8️⃣'],
    '9'       : ['9️⃣'],
    '10'      : ['🔟'],
    '100'     : ['💯'],
    '#'       : ['#️⃣'],
    '*'       : ['*️⃣'],
    '/'       : ['🥖', '🦴', '🥕'],
    '.'       : ['🕳'],
    '...'     : ['🚥', '💬'],
    '…'       : ['🚥', '💬'],
    ':'       : ['⛄️', '☃️'],
  },
};
